(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row-conditional"] && !Shopify.designMode) return;
  try {
    // open accordion row if fragment is in url
  function handleFragmentChange() {
    const url = new URL(window.location.href);
    const fragment = url.hash.substring(1);
    if (fragment) {
      const accordionRow = document.getElementById(fragment);
      if (accordionRow && accordionRow.tagName === 'DETAILS') {
        accordionRow.setAttribute('open', '');
        accordionRow.classList.add('is-open');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    handleFragmentChange();
  });

  window.addEventListener('hashchange', function () {
    handleFragmentChange();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_variant-picker"] && !Shopify.designMode) return;
  try {
    // Intercept overwriting the object (for quicker loads if changing variants often)
  const original = window.LOOP_WIDGET || {};
  Object.defineProperty(window, 'LOOP_WIDGET', {
    configurable: true,
    get() {
      return original;
    },
    set(value) {
      Object.assign(original, value);
    },
  });

  function extractLoopData(html) {
    // Get Subscription infos from fetched html
    if (!html) return null;
    const widget = html.querySelector('[id*="loop_subscriptions_loop_widget"]');
    if (!widget) return null;
    const script = widget.querySelector('script:not([src])');
    if (!script) return null;

    // add script to DOM
    const newScript = document.createElement('script');
    newScript.textContent = script.textContent;
    document.head.appendChild(newScript);
    return script;
  }

  document.addEventListener('variant:update', async function (evt) {
    if (!evt.detail.resource.available || !evt.detail.data.html) {
      return;
    }
    const productId = evt.detail.resource.product_id || evt.detail.data.productId || evt.detail.data.newProduct.id;
    const variantId = evt.detail.resource.id;

    // Init with new product if no data present
    if (!window.LOOP_WIDGET[productId]) {
      const newHtml = evt.detail.data.html;
      if (!extractLoopData(newHtml)) {
        // Fallback to copy data from current product
        const existingProductId = Object.keys(window.LOOP_WIDGET).at(0);
        window.LOOP_WIDGET[productId] = {
          product: {
            variants: [
              {
                // Use Variant data from event
                // TODO: Add more if variant does not exist yet / get data from fetched html
                ...evt.detail.resource,
              },
            ],
            // Copy data (Might not be correct for the product. (Both need to have the same selling plan))
            selling_plan_groups: window.LOOP_WIDGET[existingProductId].product.selling_plan_groups,
          },
          prepaidSellingPlans: window.LOOP_WIDGET[existingProductId].prepaidSellingPlans,
        };
        console.warn('Fallback to copy');

        try {
          await window.LoopSubscriptions.startLoopWidget(productId);
        } catch (e) {
          console.warn('Error starting Widget', e);
        }
      }
    }

    window.LoopSubscriptions.handleLoopWidgetVariantIdChange(productId, variantId);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["team-members"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // Page has loaded and theme assets are ready
    const carusel = document.getElementById("team-member-details-carusel")

    function scrollToTeamMember(i) {
      if (!carusel) return
      carusel.goToSlide(i, 0, true);
    }

    const cards = document.getElementsByClassName("team-member_card");
    for (const card of cards) {
      const index = parseInt(card.dataset.index)
      card.addEventListener("click", () => scrollToTeamMember(index))
    }
  })
  } catch(e) { console.error(e); }
})();

})();
